import despReducer from './reducers';

export { default as despTypes } from './types';
export { default as despActions } from './actions';
export { default as cadTiposSagas } from './sagas';

export default despReducer;
